const $       = require('jquery');
const _       = require('underscore');

function render(fcr) {
  return $(`
    <div class="fcr-content">
      <h1>FCR: <span>${fcr.toFixed(2)}</span></h1>
      <p>The <a target="_blank" href="https://dimensions.freshdesk.com/support/solutions/articles/23000013157-what-is-the-fcr-how-is-it-calculated-">Field Citation Ratio</a> (FCR) indicates the relative citation performance of an article, when compared to similarly-aged articles in its subject area. The FCR is normalized to 1.0 for this selection of articles. An FCR value of more than 1.0 shows that the publication has a higher than average number of citations for its group (defined by its FoR Subject Code, publishing year, and age).</p>
      <p>Articles that are less than 2 years old do not have an FCR. An article with zero citations has an FCR of 0.</p>
    </div>
  `);
}

module.exports = { render: _.memoize(render) };
